$(document).on("ready", function()
{
    const $body = $("body");

    // Picture selection
    $body.on("click", ".ficheproduit2__pictures__thumbs__view__item:not([data-selected='true'])", function()
    {
       const $media_thumb_clicked = $(this);
       const $image = $media_thumb_clicked.find("img");
       const imageSource = $image.attr("src");
       const $parent = $media_thumb_clicked.parent();
       const mediaType = $media_thumb_clicked.attr("data-type");

       if( mediaType === "picture" )
       {
           $parent.find(".ficheproduit2__pictures__thumbs__view__item").attr("data-selected", false);
           $media_thumb_clicked.attr("data-selected", true);

           $("#ficheproduit2__pictures__current").attr("src", imageSource /*+ "#" + ((new Date()).getTime())*/);
       }
       else if( mediaType === "video" )
       {

       }
    });

    // Pictures & videos gallery
    $("#ficheproduit2__pictures__current, .ficheproduit2__pictures__thumbs__view__item[data-type='video']").magnificPopup({
        "callbacks": {
            "beforeOpen": function()
            {
                $(".btCloseRightItem").css("z-index", 20);

                let $triggererElement = this.st.el,
                    $thumbsListItems = $(".ficheproduit2__pictures__view .ficheproduit2__pictures__thumbs__view__item");

                // construit la galerie à partir de la thumbslist
                this.index = -1;
                this.items = [];
                $thumbsListItems.each((i, e) =>
                {
                    let $item = $(e), item;
                    if( $item.data("type") === "picture" )
                    {
                        item = {"src": $item.find("img").attr("src"), "type": "image"};
                    }
                    else if( $item.data("type") === "video" )
                    {
                        item = {"src": $item.data("url"), "type": "iframe"};
                    }

                    this.items.push(item);

                    // définit l'index d'ouverture de la popup
                    if( this.index < 0 )
                    {
                        if( (
                                $triggererElement.is("#ficheproduit2__pictures__current")
                                && item.type === "image"
                                && item.src === $triggererElement.attr("src") )
                            || (
                                $triggererElement.is(".ficheproduit2__pictures__thumbs__view__item[data-type='video']")
                                && item.type === "iframe"
                                && item.src === $triggererElement.data("url") )
                        ) {
                            this.index = i;
                        }
                    }

                });
                console.log( this.items, this.index );
                this.updateItemHTML();
            },
            "beforeClose": function()
            {
                $(".btCloseRightItem").css("z-index", 1500);
            }
        },
        "gallery": {
            "enabled": true,
            "tPrev": "Précédente",
            "tNext": "Suivante",
            "tCounter": '<span class="mfp-counter">%curr%/%total%</span>'
        },
        "type": "image",
        "showCloseBtn": true,
        "closeBtnInside": false,
        "closeOnContentClick": false,
        "iframe": {
            "markup": '<div class="mfp-iframe-scaler">'+
                '<div class="mfp-close"></div>'+
                '<iframe class="mfp-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'+
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
            "patterns": {
                "youtube": {
                    "index": "youtube:", // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                    "id": ":", // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
                    "src": "https://www.youtube.com/embed/%id%?autoplay=1" // add &mute=1 for autoplay to work but no sound // URL that will be set as a source for iframe.
                },
                "kzam": {
                    "index": getConfig("url"),
                    "id": null, //url => url,
                    "src": "%id%"
                }
            },
        }
    });
});